import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class rolesGroupSelectionCtrl implements IController {

  roles: any;
  selectedGroups: any;
  groups: any;
  isShowChips: boolean;
  onChange: Function;

  public selectedKeys: Object = {};
  public groupRoles: any;

  private selectedChips: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.selectedGroups) {
      this.selectedGroups = [];
    }
  };

  $onChanges(changes) {
    if (changes.selectedGroups) {
      this.selectedKeys = {};
      _.forEach(this.selectedGroups, (g) => {
        this.selectedKeys[g.id] = true;
      });

      this.selectedChips = this._groupsToChip(this.selectedGroups);
    }

    if (changes.selectedGroups) {
      this.selectedChips = _.map(this.selectedGroups, (g) => {
        return {name: g.name, id: g.id};
      })

      const allRoleIds = _.uniq(_.flatMap(this.selectedGroups, 'roleIds'));
      this.groupRoles = _.map(allRoleIds, (id) => {
        return _.find(this.roles, (r) => {
          return r.id === id;
        })
      })

    }
  };

  ////////////////////////////////////////////////////////////////////////

  onClear() {
    this.selectedChips = [];
    this.onChange({groups: []})
  }

  onToggle(group) {
    const currentIndex = _.findIndex(this.selectedGroups, (g: any) => {
      return g.id === group.id;
    })

    if (currentIndex < 0) {
      this.onAdd(group);
    } else {
      this.onRemove(group);
    }
  }

  onAdd(group) {
    const updatedGroups = this.selectedGroups.concat([group]);
    this.onChange({groups: updatedGroups});
  }

  onRemove(group) {
    const updatedGroups = _.filter(this.selectedGroups, (r) => {
      return r.id !== group.id;
    });

    this.onChange({groups: updatedGroups})
  }

  _groupsToChip(groups) {
    return _.map(groups, (g) => {
      return {name: g.name, id: g.id};
    });
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .component('rolesGroupSelection', {
    bindings: {
      roles: '<',
      selectedGroups: '<',
      groups: '<',
      isShowChips: '<?',
      onChange: '&'
    },
    template: require('./roles-group-selection.html').default,
    controller: rolesGroupSelectionCtrl
  });
